import { isMobile } from 'react-device-detect';
import { store } from '../reduxToolkit/store';

const useMobileView = () => {
  const isMobileView = () => {
    const isMobilePreview = store.getState().common.isMobilePreview;
    return isMobilePreview || isMobile;
  };

  const getMobileViewWidth = () => store.getState().common.mobilePreviewWidth;
  return { isMobileView, getMobileViewWidth };
};
export default useMobileView;
